import { useState } from 'react';
import { Link } from 'react-router-dom';
import { trackFunnelEvent } from '../../lib/funnel-tracking';
import { FeatureComparison } from './FeatureComparison';

interface Props {
  isOpen:  boolean;
  onClose: () => void;
}

export function UpsellModal({ isOpen, onClose }: Props) {
  const [plan, setPlan] = useState<'monthly' | 'annual'>('monthly');

  if (!isOpen) return null;

  function handleCTA() {
    trackFunnelEvent('started_checkout', { plan });
    onClose();
  }

  const planLabel = plan === 'monthly' ? 'Mensal' : 'Anual';
  const planUrl   = plan === 'monthly' ? '/pricing?plan=monthly' : '/pricing?plan=annual';

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{
        position:   'fixed',
        inset:      0,
        zIndex:     8000,
        background: 'rgba(0,0,0,0.7)',
        backdropFilter: 'blur(4px)',
        display:    'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding:    '1rem',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background:   'var(--bg-surface)',
          border:       '1px solid var(--line-soft)',
          borderRadius: 'var(--radius-lg)',
          maxWidth:     '560px',
          width:        '100%',
          maxHeight:    '90vh',
          overflowY:    'auto',
          display:      'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--line-soft)' }}>
          <h2 style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontWeight: 400, fontSize: 'var(--text-22)', color: 'var(--bg)', margin: 0 }}>
            Escolha seu plano
          </h2>
          <button onClick={onClose} aria-label="Fechar" style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.1rem', color: 'var(--text-secondary)', lineHeight: 1, padding: '0.25rem' }}>
            ✕
          </button>
        </div>

        {/* Plan selector */}
        <div style={{ padding: '1.25rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {([
            { id: 'monthly' as const, label: 'Mensal', price: 'R$ 24,90', sub: 'por mês · cancele quando quiser', badge: undefined as string | undefined },
            { id: 'annual'  as const, label: 'Anual',  price: 'R$ 199,90', sub: 'por ano · R$ 16,66/mês', badge: 'Economize R$ 99' as string | undefined },
          ]).map(opt => (
            <button
              key={opt.id}
              onClick={() => setPlan(opt.id)}
              style={{
                position:   'relative',
                display:    'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding:    '1rem 1.25rem',
                borderRadius: 'var(--radius-sm)',
                border:     plan === opt.id ? '2px solid var(--petrol)' : '2px solid var(--line-soft)',
                background: plan === opt.id ? 'var(--bg-elevated)' : 'var(--bg-surface)',
                cursor:     'pointer',
                textAlign:  'left',
                transition: 'border-color 0.15s',
              }}
            >
              {opt.badge && (
                <span style={{
                  position:   'absolute',
                  top:        '-0.6rem',
                  right:      '0.75rem',
                  background: 'var(--petrol)',
                  color:      '#fff',
                  fontSize:   'var(--text-caption)',
                  fontWeight: 700,
                  padding:    '0.1rem 0.5rem',
                  borderRadius: '999px',
                }}>
                  {opt.badge}
                </span>
              )}
              <div>
                <p style={{ margin: 0, fontWeight: 600, color: 'var(--bg)', fontSize: 'var(--text-15)' }}>{opt.label}</p>
                <p style={{ margin: 0, fontSize: 'var(--text-caption)', color: 'var(--text-muted)' }}>{opt.sub}</p>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 'var(--text-22)', color: plan === opt.id ? 'var(--petrol)' : 'var(--bg)', fontWeight: 400 }}>{opt.price}</p>
              </div>
            </button>
          ))}
        </div>

        {/* Feature table */}
        <div style={{ padding: '0 1.5rem 1.25rem' }}>
          <FeatureComparison />
        </div>

        {/* Sticky CTA */}
        <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid var(--line-soft)', background: 'var(--bg-surface)' }}>
          <Link
            to={planUrl}
            onClick={handleCTA}
            className="btn btn-primary btn-block"
            style={{ marginBottom: '0.5rem', display: 'block', textAlign: 'center' }}
          >
            Continuar com Plano {planLabel}
          </Link>
          <p style={{ textAlign: 'center', fontSize: 'var(--text-caption)', color: 'var(--text-muted)', margin: 0 }}>
            Pagamento seguro · Cancele quando quiser
          </p>
        </div>
      </div>
    </div>
  );
}
